function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.213 15.693c-.223.34-.223.78 0 1.12 3.792 5.8 8.366 8.646 13.787 8.646 5.421 0 9.995-2.845 13.787-8.647.223-.34.223-.78 0-1.12-3.792-5.8-8.366-8.646-13.787-8.646-5.421 0-9.995 2.845-13.787 8.647zM.5 14.573C4.648 8.228 9.837 5 16 5s11.352 3.228 15.5 9.573a3.069 3.069 0 0 1 0 3.359c-4.148 6.345-9.337 9.573-15.5 9.573S4.648 24.277.5 17.932a3.069 3.069 0 0 1 0-3.359zM16 22.39a6.138 6.138 0 1 1 0-12.275 6.138 6.138 0 0 1 0 12.275zm0-2.046a4.092 4.092 0 1 0 0-8.183 4.092 4.092 0 0 0 0 8.184z"
});

var SvgShow = function SvgShow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "ac6b3d9701af3e2ad7fffe1ed11f8596.svg";
export { SvgShow as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/show.svg
// module id = null
// module chunks = 